import MyWorkReminder from "../../model2/my-work-properties/reminder"
import {ITEM_TYPE_REMINDER} from "../../gd/const/item"
import DatetimeUtils from "../../gd/utils/datetime-utils"
import ActionItemsDeprecated from "../../model2/todo/deprecated/action-items-deprecated"
import {ReminderType} from "../../model2/reminder/const"
import {ScheduleStatus} from "../../gd/types/types"

// const debug = "SessionReminderModel"
const debug = false

export default class SessionReminderModel {

    public id!              : ID
    public rid!             : RID
    public title!           : string
    public isArchived       : boolean = false
    public reminderType!    : ReminderType

    public itemType         : any
    public properties       : any
    private _myWorkProps?   : MyWorkReminder

    public scheduleStatus!  : ScheduleStatus
    public scheduleDate!    : Moment | null
    public scheduleMoment!  : Moment | null
    public momentCreated!   : Moment


    public descriptionTxt?  : string
    public descriptionRtf?  : any
    public actionItems?     : ActionItemsDeprecated // not sure

    constructor(jsonData:any, options:any={}) {

        this.itemType           = ITEM_TYPE_REMINDER  // gd.const.itemType used in resource collections

        // id: "xcCyuq"
        // title: "Reminder 1"
        // isArchived: false,
        // reminderType: 1
        // properties: null

        // scheduleDate: "2021-05-17"
        // scheduleMoment: null
        // scheduleStatus: 1

        // descriptionTxt: '',
        // descriptionRtf: null,

        // actionItems: null

        this.update(jsonData);
    }

    get myWorkProps():MyWorkReminder {
        if (!this._myWorkProps) {
            this._myWorkProps = new MyWorkReminder(this)
        }

        return this._myWorkProps
    }

    get iconClass() {
        switch (this.reminderType) {

            case ReminderType.ITEM_LINK:
                return _.get(this.properties, 'icon', 'i5-notification')

            default:
                return 'i5-notification'
        }
    }

    update(newData:any) {
        _.forEach(newData, (value, key)=>{
            switch (key) {
                case 'momentCreated'    :
                case 'scheduleDate'     :
                    // @ts-ignore
                    this[key] = value ? DatetimeUtils.dateToMoment(value) : null;
                    break;

                case 'scheduleMoment'   :
                    // @ts-ignore
                    this[key] = value ? DatetimeUtils.datetimeToMoment(value) : null; break;
                case 'actionItems'      :
                    // @ts-ignore
                    this[key] = new ActionItemsDeprecated(this, { add: true, edit: true }, value); break;
                default                 :
                    // @ts-ignore
                    this[key] = value; break;
            }
        });

        if (!this.properties) this.properties = {};

        this.rid = 'rem-' + this.id
    }

    _isSameValue(paramName:string, value:any) {
        // @ts-ignore
        if (moment.isMoment(this[paramName])) {
            // @ts-ignore
            return DatetimeUtils.isSame(this[paramName], DatetimeUtils.dateToMoment(value), 'minute')
        } else {
            // @ts-ignore
            return _.isEqual(this[paramName],value)
        }
    }

    applyDelta(data:any) {
        let isChanged = false

        _.mapKeys(data, (value ,key)=>{
            if (key === 'id') return;

            debug && console.log(debug, "applyDelta", "key=", key, "value=", value)

            switch (key) {
                case 'scheduleDate'     :
                    if (!this._isSameValue(key, value)) {
                        const moment = value ? DatetimeUtils.dateToMoment(value) : null
                        this.scheduleDate   = moment
                        this.scheduleMoment = moment && this.scheduleMoment ? DatetimeUtils.setTime(moment,this.scheduleMoment) : null
                        isChanged = true
                    }
                     break
                case 'scheduleMoment'   :
                    if (!this._isSameValue(key, value)) {
                        const moment = value ? DatetimeUtils.datetimeToMoment(value) : null
                        this.scheduleDate   = moment
                        this.scheduleMoment = moment
                        isChanged = true
                    }
                    break
                case 'actionItems'      :
                    if (!this._isSameValue(key, value)) {
                        this[key] = new ActionItemsDeprecated(this, { add: true, edit: true }, value)
                        isChanged = true
                    }
                    break
                default                 :
                    // @ts-ignore
                    this[key] = value
                    break
            }
        })

        debug && console.log(debug, "applyDelta isChanged", isChanged, this)

        return isChanged
    }

    setCompleted = (value = true) => {this.isArchived = value; this.save('isArchived');}

    setTitle = (value:string) => {
        this.title = value; this.save('title');
    }

    setDescription = (text:string, rtf:any) =>      {
        this.descriptionTxt = text;
        this.descriptionRtf = rtf;
        this.save(['descriptionTxt', 'descriptionRtf']);
    }

    setScheduleDate =       (value:Moment|null) => {
        this.scheduleDate = value;
        this.scheduleMoment = value && this.scheduleMoment ? DatetimeUtils.setTime(value,this.scheduleMoment) : null

        this.save(['scheduleDate', 'scheduleMoment'])
    }

    setScheduleMoment =     (value:Moment|null) => {
        if (!this.scheduleDate) this.scheduleDate = value
        this.scheduleMoment = value ? DatetimeUtils.setTime(this.scheduleDate,value) : null

        this.save(['scheduleDate', 'scheduleMoment'])
    }

    save = (updateParameters:any) => {
        const res = this.toJSON();
        const updateData = updateParameters ? _.pick(res, updateParameters) : res;
        gd.api.Reminder.update(res.id, updateData);
    }

    delete = () => gd.api.Reminder.delete(this.id)

    toJSON() {
        const res : any = {
            id              : this.id,
            title           : this.title,
            isArchived      : !!this.isArchived,
            reminderType    : this.reminderType,
            scheduleStatus  : this.scheduleStatus,
            scheduleDate    : DatetimeUtils.momentToDate(this.scheduleDate),
            scheduleMoment  : this.scheduleMoment ? DatetimeUtils.momentToUTCISODatetime(this.scheduleMoment) : null,
            momentCreated   : DatetimeUtils.momentToDate(this.momentCreated),
        }

        if (!_.isNil(this.properties))      res.properties = this.properties;
        if (!_.isNil(this.descriptionTxt))  res.descriptionTxt = this.descriptionTxt;
        if (!_.isNil(this.descriptionRtf))  res.descriptionRtf = this.descriptionRtf;
        if (!_.isNil(this.actionItems))     res.actionItems = this.actionItems.toJSON();

        return res;
    }
}
